import RestaurantMealsRoutes from './restaurant'

const RestaurantRoutes = [
  ...RestaurantMealsRoutes
]

export default RestaurantRoutes
